import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=4d1acf90&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d1acf90')) {
      api.createRecord('4d1acf90', component.options)
    } else {
      api.reload('4d1acf90', component.options)
    }
    module.hot.accept("./Player.vue?vue&type=template&id=4d1acf90&", function () {
      api.rerender('4d1acf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/preview/Player.vue"
export default component.exports